import FadeInUp from "../../../components/FadeInUp";
import useIsMobile from "../../../hook/useIsMobile"

export default function CoreFeatures() {

  const isMobile = useIsMobile();

  return (
    <section className='wrapper top-space'>
      <div className='flex gap-[80px] lg:gap-[120px]'>
        { !isMobile && 
          <FadeInUp delay={0.5} className='w-[40%]'>
            <img 
              className=" aspect-[420/620] rounded-[20px] object-cover object-center"
              alt='기능1'
              src={`${process.env.REACT_APP_STATIC_URL}/images/main/core_feature1.jpg`}
            />
            </FadeInUp> 
          }
        <div className='flex flex-col justify-between lg:w-[60%]'>
          <FadeInUp>
            <div className="font-bold text-body2 lg:text-heading1 text-primary-400">핵심 기능 첫 번째</div>
            <div className='font-bold text-title3 lg:text-display3'>주행 사고 실시간 감지</div>
          </FadeInUp>
          {isMobile && 
            <FadeInUp>
              <img 
                className="w-full aspect-[335/420] my-[32px] rounded-[20px] object-cover object-center"
                alt='기능1'
                src={`${process.env.REACT_APP_STATIC_URL}/images/main/core_feature1.jpg`}
              />
            </FadeInUp>
          }
          <FadeInUp className='font-normal text-heading1 text-label-300'>
            보행 보조 전동차에 부착된 링콜 제품은 주행 중에 발생할 수 있는 사고를 실시간으로 감지합니다.
            <br/><br/>
            자이로 센서와 가속도 센서를 통해 전복, 충돌, 낙하 등 차량의 급격하고 비정상적인 움직임을 자동으로 인식하며, 사고로 판단되는 상황이 발생하면 스마트폰 앱을 통해 구조 요청 신호가 자동으로
            전송되어 신속한 대응이 가능하도록 돕습니다.
          </FadeInUp>
        </div>
      </div>

      <div className='flex gap-[80px] mt-[140px]'>
        <div className='flex flex-col justify-between lg:w-[60%]'>
          <FadeInUp>
            <div>
              <div className="font-bold text-body2 lg:text-heading1 text-primary-400">핵심 기능 두 번째</div>
              <div className='font-bold text-title3 lg:text-display3'>자동 응급 구조 요청 신고</div>
            </div>
          </FadeInUp>
          {isMobile && 
            <FadeInUp>
              <img 
                className="w-full aspect-[335/420] my-[32px] rounded-[20px] object-cover object-center"
                alt="주요 기능2"
                src={`${process.env.REACT_APP_STATIC_URL}/images/main/core_feature2.jpg`}
              />
            </FadeInUp>
          }
          <FadeInUp>
            <div className='font-normal text-heading1 text-label-300'>
              링콜은 사고로 판단되면, BLE를 통해 스마트폰 앱과 연동되어 자동으로 구조 요청 신호를 전송합니다.
              <br/><br/>
              이때 GPS 위치, 이름, 성별, 나이, 연락처, 병력 등 사전 등록된 응급정보가 함께 전송되어, 구조 기관이 신속하게 대응할 수 있도록 합니다.
              <br/><br/>
              구조 요청 후 일정 시간 내에 버튼을 짧게 누르면 요청이 취소되며, 별도의 조치가 없을 경우 요청이 유지됩니다.
            </div>
          </FadeInUp>
        </div>
        { !isMobile && 
          <FadeInUp delay={0.5} className='w-[40%]'>
            <img 
              className="w-full aspect-[420/620] rounded-[20px] object-cover object-center"
              alt="주요 기능2"
              src={`${process.env.REACT_APP_STATIC_URL}/images/main/core_feature2.jpg`}
            />
          </FadeInUp> 
        }
      </div>
    </section>
  )
}